import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {AlertController, LoadingController, ModalController, NavController, ToastController} from '@ionic/angular';
import {ActivatedRoute} from '@angular/router';
import {ServerService} from '../../service/server.service';
import {AdminService} from '../../service/admin.service';
import {Constant} from '../../shared/model/Constant';

@Component({
  selector: 'app-profile-add',
  templateUrl: './profile-add.page.html',
  styleUrls: ['./profile-add.page.scss'],
})
export class ProfileAddPage implements OnInit {

  @ViewChild('input', {static: false}) searchInput: { setFocus: () => void };
  @ViewChild('formProfile', {static: false}) ngForm: NgForm;


  name: any;
  qty: any;
  price: any;
  data: any = [];
  type: any = 0;
  title: any;
  url: any;
  logo: any;
  states: any;
  product: any;
  text: any;
  dealers: any[];
  formProfile: FormGroup;

  constructor(public alertController: AlertController,
              private route: ActivatedRoute,
              public server: ServerService,
              public toastController: ToastController,
              private nav: NavController,
              public loadingController: LoadingController,
              private adminService: AdminService,
              private formBuilder: FormBuilder,
              public modalController: ModalController) {

    this.type = this.route.snapshot.paramMap.get('type');

    if (!localStorage.getItem(Constant.userId) ||
      localStorage.getItem(Constant.userId) == undefined ||
      localStorage.getItem(Constant.userId) == 'null') {
      this.nav.navigateRoot('/home');
    }

  }

  ngOnInit() {
    this.initForm();
    this.getStates();
    this.getDealers();
  }

  initForm() {
    this.formProfile = this.formBuilder.group({
      dealerId: ['', Validators.required],
      name: ['', Validators.required],
      state: ['', Validators.required]
    });
  }

  ionViewDidEnter() {
    if (localStorage.getItem(Constant.products) && localStorage.getItem(Constant.products) != undefined && localStorage.getItem(Constant.products) != 'null') {
      this.data = JSON.parse(localStorage.getItem(Constant.products));
    }
    this.getStates();
  }

  getName() {
    for (let i = 0; i < this.states.length; i++) {
      if (this.states[i].id == this.product) {
        this.name = this.states[i].name;
        this.price = this.states[i].price;
        this.qty = 1;
      }
    }
  }

  async addProfile(data) {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
    await loading.present();
    this.adminService.createProfile(data).subscribe(response => {
      loading.dismiss();
      this.presentToast('Perfil creado con éxito');
      this.close(true);
      this.ngForm.reset();
    }, error => {
      console.warn('Error al crear perfil', error);
      loading.dismiss();
      this.presentToast(error.error.error);
    });
  }


  getStates() {
    this.states = [
      {value: 1, label: 'Activo'},
      {value: 0, label: 'Inactivo'}
    ];
  }


  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

  getDealers() {
    this.adminService.getAllCompanies().subscribe((value: any[]) => {
      this.dealers = value;
      console.log(value);
    });
  }

  async remove() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: this.text.are_you_sure,
      message: this.text.remove_product,
      mode: 'ios',
      buttons: [
        {
          text: this.text.cancel,
          role: 'cancel',
          cssClass: 'secondary',
          id: 'cancel-button',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: this.text.cancel,
          id: 'confirm-button',
          handler: () => {

            localStorage.setItem(Constant.products, null);
            this.data = [];

          }
        }
      ]
    });

    await alert.present();
  }
  async close(data?: any) {
    await this.modalController.dismiss(data);
  }
}
